module.exports = __webpack_public_path__ + "fonts/f39bac7.ttf";